let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jTKK6")).then(() => parcelRequire('4pG8m'));